"use client";

import {ThemeProvider} from "next-themes";
import React from "react";
import {CSPostHogProvider} from "@/hooks/postHogProvider";
import useMautic from "@/hooks/useMautic";

export function Providers({children}: { children: React.ReactNode }) {
    useMautic();
    return (
        <CSPostHogProvider>
            <ThemeProvider attribute="class" enableSystem={false} defaultTheme="light">
                {children}
            </ThemeProvider>
        </CSPostHogProvider>

    );
}
